import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private sidebarToggle = new BehaviorSubject<boolean>(true)
  private totalData = new BehaviorSubject<number>(0)
  private user_detail = new BehaviorSubject<any>({})
  private user_modal = new BehaviorSubject<any>({})
  private segment_modal = new BehaviorSubject<any>({})
  private shareContentPoolStatus = new BehaviorSubject<any>([])


  $sidebarToggle = this.sidebarToggle.asObservable();

  changeSideToggle(value: boolean) {
    this.sidebarToggle.next(value)
  }

  getSharedData() {
    return this.totalData.asObservable();
  }

  updateSharedData(total: number) {
    this.totalData.next(total);
  }

  getUserDetail() {
    this.user_detail.next(JSON.parse(localStorage.getItem('user_detail') || '{}'));
    return this.user_detail.asObservable();
  }

  updateUserDetail(user: any) {
    this.user_detail.next(user);
  }

  updateUserModal(user: any) {
    this.user_modal.next(user);
  }

  getUserModal() {
    return this.user_modal.asObservable();
  }

  updateSegmentModal(segment: any) {
    this.segment_modal.next(segment);
  }

  getSegmentModal() {
    return this.segment_modal.asObservable();
  }

  updateShareContentPoolStatus(contentPoolStatus: any) {
    this.shareContentPoolStatus.next(contentPoolStatus);
  }

  getShareContentPoolStatus() {
    return this.shareContentPoolStatus.asObservable();
  }
 

}
